import React from 'react';
import { useAutenticacao } from './contextos/AutenticacaoContexto';
import Login from './componentes/Login/Login';
import Download from './componentes/Download/Download';
import './App.css';

function App() {
  const { token, carregando } = useAutenticacao();

  if (carregando) {
    return (
      <div className="containerCarregamento">
        <div className="spinnerPrincipal"></div>
        <p>Carregando...</p>
      </div>
    );
  }

  return (
    <div className="App">
      {token ? <Download /> : <Login />}
    </div>
  );
}

export default App;
